
import { UserService } from 'src/app/service/user-service.service';
import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ColumnMode } from '@swimlane/ngx-datatable';
import { ToastrService } from 'ngx-toastr';
import { SelectItem } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { InputModalComponent } from 'src/app/modals/input-modal/input-modal.component';
import { Observation } from 'src/app/model/Observation';
import { Page } from 'src/app/model/page';
import { endpoints } from 'src/endpoint/endpoints';
import { PazientiService } from '../service/pazienti.service';
import { AlertService } from '../alert-management/service/alert.service';
import { FormControl, FormGroup } from '@angular/forms';
import { addPaddingToNumber } from 'src/app/utils/utils';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ConfirmModalComponent } from 'src/app/modals/confirm-modal/confirm-modal.component';

@Component({
  selector: 'app-notifiche',
  templateUrl: './notifiche.component.html',
  styleUrls: ['./notifiche.component.scss']
})
export class NotificheComponent implements OnInit {
  ColumnMode = ColumnMode;
  colonne = [
    { name: 'Paziente', prop: 'patient' },
    { name: 'Notifica', prop: 'notifica' },
    { name: 'Tipologia', prop: 'type' },
    { name: 'Data', prop: 'date' },
    // { name: 'Azioni', prop: 'azioni' },
  ];

  page = new Page();

  datePipe = new DatePipe('en-US');

  patientId;

  indirizzo;

  rows = [];

  subscriber;

  observations = [];

  pageRef;

  patientIdentifier;

  statusAlert = '&status=registered';

  registered = true;

  observation = new Array<Observation>();

  subAlert;

  countAlerts;

  selectActions;

  listItem: SelectItem[] = [];

  itemSelected = 'registered';

  performers = new Array();

  first = 0;

  parametriQuery = {
    category: "notification",
    count: null,
    status: null,
    pageoffset: null,
    sort: null
  };

  typesOptions = [
    { label: "Tutte", value: "" },
    { label: "Self-report", value: "NotificationSelfReport" },
    { label: "ECG", value: "NotificationEcg" },
    { label: "Utilizzo smartwatch", value: "NotificationSmartwatch" },
  ];

  formRicerca: FormGroup;

  datePickerConf = { isAnimated: true, adaptivePosition: true, withTimepicker: false, rangeInputFormat: 'DD/MM/YYYY', dateInputFormat: 'DD/MM/YYYY', containerClass: 'theme-dark-blue' };

  // tslint:disable-next-line: max-line-length
  constructor(private http: HttpClient, private dialogService: DialogService, private pazientiService: PazientiService, private ref: ChangeDetectorRef, private toastr: ToastrService, public route: ActivatedRoute, private alertService: AlertService,
    private usrService: UserService, private modalService: BsModalService) { }

  ngOnInit() {
    this.listItem = [
      { label: 'Nuove', value: 'registered', icon: 'far fa-bell text-danger' },
      { label: 'Lette', value: 'corrected', icon: 'far fa-bell text-success' },
    ];

    this.buildForm();
    this.rows = [];
    this.page.size = 10;

    this.parametriQuery.count = this.page.size;
    this.parametriQuery.status = "registered";
    this.countAlerts = this.verifyAlert(this.patientId);
  }

  getDefaultPeriod(): [Date, Date] {
    let setteGiorniFa = new Date();
    setteGiorniFa.setTime((new Date()).getTime() - (604800 * 1000));
    return [setteGiorniFa, new Date()]
  }

  buildForm() {

    this.formRicerca = new FormGroup({
      'patientFilter': new FormControl(''),
      'typeFilter': new FormControl(this.typesOptions[0].value),
      'periodo': new FormControl(this.getDefaultPeriod())
    });

    this.formRicerca.valueChanges.subscribe(v => {
      this.getRows();
    });
  }

  ngOnDestroy() {
    if (this.subscriber != undefined) {
      this.subscriber.unsubscribe();
    }    //this.subAlert.unsubscribe();
  }

  setPage(pageInfo) {
    this.pageRef = pageInfo;
    this.first = this.pageRef.first;
    this.parametriQuery.pageoffset = pageInfo.first;
    this.parametriQuery.sort = "=-_id";
    this.page.pageNumber = pageInfo.first;
    this.getRows();
  }

  verifyAlert(patientId) {
    this.http.get(endpoints.getCountAlertByPatientId + patientId).toPromise().then((resp: any) => {
      this.countAlerts = resp.total;
    });
  }
  getPatientId(pat) {
    if (pat && pat.identifier) {
      const identifier = pat.identifier.find(identifierCode => identifierCode.use == "usual");
      return identifier ? identifier.value : "";
    } else {
      return "";
    }
  }

  getRows() {
    if (this.formRicerca.get("periodo").value == undefined) {
      this.formRicerca.get("periodo").patchValue(this.getDefaultPeriod(), false);
    }
    let filters = "";
    filters = "?subject=" + this.formRicerca.get("patientFilter").value ?? "";
    filters += "&type=" + (this.formRicerca.get("typeFilter").value.value ?? this.formRicerca.get("typeFilter").value ?? "");
    const periodForm = this.formRicerca.get("periodo").value;
    const start = (periodForm[0] as Date).getFullYear() + "-" + addPaddingToNumber(((periodForm[0] as Date).getMonth() + 1)) + "-" + addPaddingToNumber((periodForm[0] as Date).getDate());
    const end = (periodForm[1] as Date).getFullYear() + "-" + addPaddingToNumber(((periodForm[1] as Date).getMonth() + 1)) + "-" + addPaddingToNumber((periodForm[1] as Date).getDate());
    filters += "&start=" + start;
    filters += "&end=" + end;
    let path = endpoints.getAllNotification;
    for (let parametro in this.parametriQuery) {
      path += "/" + this.parametriQuery[parametro];
    }
    path += filters;
    this.rows = [];
    this.http.get(path).subscribe(async (resp: any) => {
      this.page.totalElements = resp.total;
      this.page.totalPages = resp.total / 10;
      if (resp.entry == undefined) {
        resp.entry = new Array();
      }
      resp.entry = resp.entry.filter(o => o.resource.resourceType == 'Observation');
      if (resp.entry) {
        this.observations = [];
        resp.entry.forEach(elem => {
          this.observations.push(elem);
        });
        this.rows = await Promise.all(resp.entry.map(async elem => ({
          id: elem.resource.id,
          patient: await this.pazientiService.getPatientFromServerByPatientId(elem.resource.subject.reference).then((resp: any) => {
            return this.pazientiService.getPatientIdentifier(resp.message);
          }),
          notifica: elem.resource.valueString,
          type: this.getTypeMeasure(elem.resource.code.coding[0].code),
          // tslint:disable-next-line: max-line-length
          date: elem.resource.effectiveDateTime ? this.datePipe.transform(new Date(Date.parse(elem.resource.effectiveDateTime)), 'dd/MM/yyyy') : '',
        })
        ))

      } else {
        this.rows = [];
      }
    });

  }

  getTypeMeasure(code) {
    switch (code) {
      case 'NotificationEcg': return 'ECG';
      case 'NotificationSmartwatch': return 'Utilizzo Smartwatch';
      case 'NotificationSelfReport': return 'Self-report';
      default: return '';
    }
  }


  getLevel(value, range) {
    if (value > range.high.value) {
      if ((value - range.high.value) <= range.high.value / 100 * 10) {
        return 1;
      } else {
        return 2;
      }
    } else if (value < range.low.value) {
      if ((value - range.low.value) <= range.low.value / 100 * 10) {
        return 1;
      } else {
        return 2;
      }
    }
  }

  checkVisualizzaVerificato() {
    return true;
  }

  setVerificato(id) {
    this.http.put(endpoints.updateNotificationStatus, id).toPromise().then(resp => {
      this.getRows();
    })
      .catch(error => {
        if (error.status == 404) {
        } else {
          console.error("error ", error);
        }
      });
  }


  getTypeAlert(type) {
    this.rows = [];
    this.pageRef.first = 0;
    this.first = 0;
    if (type.value === 'registered') {
      this.registered = true;
      //this.statusAlert = '&status=registered';
      this.parametriQuery.status = "registered";
      // tslint:disable-next-line: max-line-length
      this.setPage(this.pageRef);
    } else {
      this.registered = false;
      // this.statusAlert = '&status=corrected';
      this.parametriQuery.status = "final";
      // tslint:disable-next-line: max-line-length
      this.setPage(this.pageRef);
    }
  }


  setActions(event, actions, op) {
    this.selectActions = actions;
    op.toggle(event);
  }

  getNotification(): Promise<any[]> {
    return this.http.get(endpoints.getAllNotification)
      .toPromise()
      .then((resp: any) => {
        let listaNotifiche = [];
        resp.forEach(e => {
          listaNotifiche.push(e);
        });
        return listaNotifiche;
      })
      .catch(error => {
        if (error.status == 404) {
        } else {
          console.error("error ", error);
        }
        return [];
      });
  }

  setAllRead() {
    let confermaModalRef = this.modalService.show(ConfirmModalComponent, { initialState: { message: "Proseguendo verranno lette tutte le notifiche in questa pagina. Continuare?" } });
    const newSubscriber = this.modalService.onHide.subscribe(r => {
      newSubscriber.unsubscribe();
      const res = confermaModalRef.content.result;
      if (res) {
        let ids = [];
        this.rows.forEach(element => {
          ids.push(element.id);
        });
        this.http.post(endpoints.readAllNotifications, ids).toPromise().then(resp => {
          this.toastr.success("Stato delle notifiche salvato con successo.");
          this.getRows();
        }).catch(error => {
          this.toastr.error("Errore nel salvataggio delle risorse.");
        });
      }
    });
  }

}
